import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from "recharts";

const COLORS = [
    "var(--valtekPrimary)",
    "var(--valtekGreen)",
    "var(--valtekWarning)",
    "var(--valtekInfo)",
];

const CustomTooltip = ({ active, payload }) => {
    if (!active || !payload?.length) return null;
    const item = payload[0].payload;
    return (
        <div
            style={{
                background: "#fff",
                padding: "10px 14px",
                borderRadius: 8,
                boxShadow: "0 8px 25px rgba(0,0,0,.25)",
                color: "#000"
            }}
        >
            <strong>{item.termName}</strong>
            <div style={{ marginTop: 6 }}>{item.count} öğrenci</div>
        </div>
    );
};

const EnrollmentByTermChart = ({ data = [] }) => {
    const chartData = data.map((d) => ({
        ...d,
        label: d.termName || d.termCode || "Dönem"
    }));

    return (
        <div className="card">
            <h3 className="card-title">Döneme Göre Kayıtlı Öğrenciler</h3>
            <ResponsiveContainer width="100%" height={260}>
                <BarChart
                    data={chartData}
                    margin={{ top: 30, right: 20, left: -20, bottom: 60 }}
                >
                    <XAxis
                        dataKey="label"
                        tick={{ fill: "#fff", fontSize: 12, angle: -45, textAnchor: "end" }}
                        interval={0}
                    />
                    <YAxis allowDecimals={false} tick={{ fill: "#fff" }} />
                    <Tooltip content={<CustomTooltip />} />
                    <Bar dataKey="count" radius={[8, 8, 0, 0]}>
                        {chartData.map((_, i) => (
                            <Cell key={i} fill={COLORS[i % COLORS.length]} />
                        ))}
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
};

export default EnrollmentByTermChart;
